import { render, staticRenderFns } from "./CompanyDeactivateModal.vue?vue&type=template&id=421dc194&"
import script from "./CompanyDeactivateModal.vue?vue&type=script&lang=js&"
export * from "./CompanyDeactivateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports